import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {CSSTransition} from 'react-transition-group';
import styled from 'styled-components';

import {gt} from 'app/utils/i18n';

type Props = {
  email: string | null | undefined;
};
export function WarnEmailNotVerifiedBanner({email}: Props): JSX.Element {
  return (
    <CSSTransition
      appear={true}
      in={true}
      timeout={500}
      classNames="banner"
      unmountOnExit
    >
      <StyledTransitionDiv>
        <div className="py-2 px-4 d-flex justify-content-between align-items-center">
          <div>
            <span className="mr-0 mr-md-2">
              <i className="far fa-envelope mr-2 d-none d-md-inline" />
              {gt(
                `Please verify ${
                  email != null ? email : 'your email'
                } by clicking the link in the email sent to you. All unverified accounts are logged out each hour.`
              )}
            </span>
          </div>
        </div>
      </StyledTransitionDiv>
    </CSSTransition>
  );
}

const StyledTransitionDiv = styled.div`
  overflow: hidden;

  &.banner-exit {
    max-height: 50px;
  }

  &.banner-exit-active {
    max-height: 1px;
    transition: all 500ms ease-in-out;
  }

  & > div {
    background-color: ${colors.alertBg};
    font-size: 0.9rem;
    color: ${colors.alertText};
    transition: all 250ms;
    max-height: 100px;

    a {
      color: ${colors.alertText};
      font-weight: bold;
    }
  }
`;
